import { toast } from 'react-toastify'
import {
  // getAllPolicies,
  getAllPoliciesAgreements,
  // getAllPolicyById,
  getAllPublishedPolicies,
  getPublishedPolicyById,
} from '../../../api/candidate/policies'
import {
  getSinglePolicy,
  policiesAgreement,
  policiesAgreementResponse,
  policyResponse2,
  policyResponseObject,
} from '../../../utils/types'

export const getPolicyData = async (): Promise<policyResponse2> => {
  const response = (await getAllPublishedPolicies()) as policyResponse2

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response
}

export const getPolicyAgreement = async (): Promise<policiesAgreement[]> => {
  const response =
    (await getAllPoliciesAgreements()) as policiesAgreementResponse

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}

export const getPolicyDataById = async (
  id: string
): Promise<getSinglePolicy> => {
  const response = (await getPublishedPolicyById(id)) as policyResponseObject

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}
